import React from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white/98 backdrop-blur-xl z-50 border-b border-gray-100">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_blackbird-redesign/artifacts/iuwp2epg_logo-trade-black-svg.svg" 
              alt="Blackbird Trade Group" 
              className="h-14"
            />
          </Link>
          <nav className="hidden lg:flex items-center gap-10">
            <Link to="/about" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">About</Link>
            <Link to="/services" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Services</Link>
            <Link to="/resources" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Resources</Link>
            <Link to="/blog" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Insights</Link>
            <Link to="/blackbird-ai" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">Blackbird AI</Link>
            <Link to="/contact">
              <Button className="bg-slate-700 hover:bg-slate-800 text-white px-6 h-10 text-sm font-medium">
                Contact Us
              </Button>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;